import { createContext, useContext } from 'react'

/**
 * Whether the document on screen stands between two bars — the left one holding
 * its contents and the open documents, the right one its tools and the band's
 * views. A page reads this to leave out the entry points the bars already
 * are: a rail of views beside a bar that draws them is the same control twice.
 */
export const DocBarsContext = createContext(false)

export const useDocBars = () => useContext(DocBarsContext)

/**
 * Reading together, as the person has turned it on or off.
 *
 * The right rail holds the switch; the bar it opens at the top center holds who
 * is here. A document with nobody to read with reports nothing, and is offered
 * no switch.
 */
export type Together = {
  on: boolean
  setOn: (on: boolean) => void
  /** How many others are here, or null where the document has no room. */
  report: (here: number | null) => void
}

export const TogetherContext = createContext<Together | null>(null)

export const useTogether = () => useContext(TogetherContext)
